import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import axios from 'axios'
import {
  PASSWORD_MIN_LENGTH,
  PASSWORD_MAX_LENGTH,
} from '../../Utils/passwordValidation'
import './Login.css' // Import your CSS file

function ResetPassword() {
  const navigate = useNavigate()
  const { token } = useParams()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [values, setValues] = useState({
    password: '',
    confirmPassword: '',
  })

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMessage('')
    setError('')

    if (values.password !== values.confirmPassword) {
      setError('Passwords do not match')
      return
    }

    if (values.password.length < PASSWORD_MIN_LENGTH) {
      setError(`Password must be at least ${PASSWORD_MIN_LENGTH} characters`)
      return
    }

    if (values.password.length > PASSWORD_MAX_LENGTH) {
      setError(`Password cannot exceed ${PASSWORD_MAX_LENGTH} characters`)
      return
    }

    if (!token) {
      setError('Invalid reset token')
      return
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}reset-password`,
        {
          token,
          password: values.password,
        }
      )

      setMessage(response.data.message || 'Password reset successfully!')
      setTimeout(() => {
        navigate('/')
      }, 2000)
    } catch (error) {
      setError(
        error.response?.data?.message ||
          'An error occurred while resetting password'
      )
    }
  }

  return (
    <div class="login-container">
      <div class="image-div">
        <img src="/images/login_Illustration.svg" />
      </div>
      <div class="form-div">
        <div class="form-container">
          <img src="/logo.png" alt="Brilliant Prep Logo" class="logo" />
          <div class="form-header">Reset Password</div>
          <Link to="/" class="signup-link">
            <span>Remember your password?</span> Sign In →
          </Link>

          <form autoComplete="off" onSubmit={(e) => handleSubmit(e)}>
            <div class="inputBox">
              <input
                placeholder="New Password"
                id="pass"
                type="password"
                name="password"
                value={values.password}
                onChange={(e) =>
                  setValues({ ...values, [e.target.name]: e.target.value })
                }
              />

              <input
                placeholder="Confirm Password"
                id="confirmPass"
                type="password"
                name="confirmPassword"
                value={values.confirmPassword}
                onChange={(e) =>
                  setValues({ ...values, [e.target.name]: e.target.value })
                }
              />
            </div>

            <div class="login-btn">
              <input type="submit" value="Reset Password" />
            </div>

            <div class="forgotpassword">
              <Link to="/login" class="forgot-link">
                Back to Login
              </Link>
            </div>
          </form>
          {message && <p style={{ color: 'green' }}>{message}</p>}
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
      </div>
    </div>
  )
}

export default ResetPassword
